var _utils = _utils || (($) => {
  var fx = {
    onElementLoad(selector, callback) {
      var t = setInterval(function() {
        var element = document.querySelector(selector);
        if (element !== null && element !== undefined) {
          clearInterval(t);
          callback();
        }
      }, 100);
    },
    
    getCart() {
      return $.getJSON('/cart.js');
    },

    addItemsToCart(items) {
      return $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {items: items},
        dataType: 'json'
      });
    },
    
    removeItemsFromCart(items) {
      // Pass an array of line item KEYS
      if (items.length == 0) {
        return;
      }

      var updates = {};
      items.forEach(function(item) {
        updates[item.key] = 0;      
      });

      //console.log(updates);
      return $.post('/cart/update.js', {
        updates: updates
      }, null, 'json');
    },

    getRandomUniqId() {
      return '_' + Math.random().toString(36).substr(2, 9);
    },
    
    formatMoney(value) {
      return theme.Currency.formatMoney(value, theme.settings.moneyFormat);
    },
    
    showCart() {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: null,
          addToCartBtn: null
        }
      }));      
    }
  };
    
  return fx;
})(jQuery);

(function($) {
  function updateCartCount() {
    const CART_BUBBLE_VISIBLE_CLASS = 'cart-link__bubble--visible';
    $(`.${CART_BUBBLE_VISIBLE_CLASS}`).removeClass(CART_BUBBLE_VISIBLE_CLASS);
    _utils.getCart()
    .then((cart) => {
      var cart_item_count = cart.items.reduce((sum, item) => {
        let quantity = item.product_type == 'custom-letter-fee' ? 1 : item.quantity;
        return sum + quantity; 
      }, 0);
      $('.cart-link__bubble .cart-link__bubble-num').text(cart_item_count);
      if (cart_item_count > 0) {
        $('.cart-link__bubble').addClass(CART_BUBBLE_VISIBLE_CLASS);
      }
    });
  }
  
  function ProductCustomLetters() {
    const SETTINGS = {
      warn_msg: 'Enter Message'
    };
    
    // remove product customizer app stuff
    _utils.onElementLoad('.product-customizer-options', function() {
      $('.product-customizer-options').remove();
    });
    
    // hide qty
    $('.product__quantity').hide();
    // hide additional buttons
    $('.shopify-payment-button').remove();
    
    // only allow specific characters
    const alpha = Array.from(Array(26)).map((e, i) => i + 65);
    const alphabet = alpha.map((x) => String.fromCharCode(x));
    const special = ['Ä', 'Ö', 'Ü', 'ß', '!', '?', '#', '-', '&'];
    $(document).on('keypress', '#custom-letters', function(e) {
      var target = e.target;
      setTimeout(function() {
        var allowed = [].concat(alphabet, special, [' ']);
        if (allowed.indexOf(e.key.toUpperCase()) == -1) {
          target.value = target.value.replaceAll(e.key, '');
        }
        target.value = target.value.toUpperCase();
      }, 0);
    });
    
    // add to cart
    $(document).on('click', '.add-to-cart', function(e) {
      if ($('#custom-letters').length) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var $target = $(e.currentTarget);
        var random_id = _utils.getRandomUniqId();
        var $custom_letters = $('#custom-letters');

        var $form = $target.closest('.product-single__form');
        var variant_main_id = $form.find('[name=id]').val();
        var product_main = $custom_letters.data('product-main');
        var variant_main = product_main.variants.find(v => v.id == variant_main_id);

        var product_letters = $custom_letters.data('product-letters');
        var variant_letters_id = $custom_letters.attr('data-variant-id');
        var variant_letters = product_letters.variants.find(v => v.id == variant_letters_id);
        var letters_count = $custom_letters.val().replaceAll(' ', '').length;

        var total_price = (variant_letters.price * letters_count);

        var items_to_add = [
          {
            id: variant_main_id,
            quantity: letters_count,
            properties: {
              _id: random_id,
              Letters: $custom_letters.val(),
              _totalPrice: _utils.formatMoney(total_price)
            }
          }
        ];

        if ($custom_letters.val().length == 0) {
          alert(SETTINGS.warn_msg);
          return;
        }

        _utils.addItemsToCart(items_to_add)
        .then(_utils.showCart)
        .catch(console.error)        
      }
    });
    
    // remove item from cart
    $(document).on('click', '[data-remove-bundle]', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      var $remove = $(e.currentTarget);
      var bundle_id = $remove.data('id');

      _utils.getCart()
      .then(cart => {
        var bundle_items = cart.items.filter(item => item.properties._id == bundle_id);
        _utils.removeItemsFromCart(bundle_items);
        setTimeout(function() {
          window.location.reload();
        }, 250);
      });
    });
    
    // on variant change
    document.addEventListener('variant:change', function(e) {
      var format_money = '€{{ amount_with_comma_separator }}';
      var letter_price = Shopify.formatMoney(e.detail.variant.price, format_money);
      $('.letter-fee').text(letter_price);
      $('#custom-letters').attr('data-variant-id', e.detail.variant.id);
    });
    
    // on cart updated, show new count
    document.addEventListener('ajaxProduct:added', function(e) {
      updateCartCount();
      setTimeout(updateCartCount, 250);
    });
    updateCartCount();
    setTimeout(updateCartCount, 250);
  }
  
  $(document).ready(function() {
    //console.log('READY');
    ProductCustomLetters();
  });
})(jQuery);